module.exports = __webpack_public_path__ + "static/media/Avadhoot.e7d331d9.jpg";